let video = document.getElementById('js-video');

/**
 * Determine screen size and select mobile or desktop vid.
 * @returns {void}
 *
 */
function changeVideo() {
    let width = window.innerWidth;
    let url = document.getElementById('js-data-container').dataset.externalVideos;

    if (width < 500) {
        url += 'about-us-390x665.mp4';
    } else if (width >= 500 && width < 1020) {
        url += 'about-us-768x1100.mp4';
    } else {
        url += 'about-us-1920x1080.mp4';
    }

    video.src = url;
}

changeVideo(); // Don't wait for document to load, therefore it's not in an event listener. This is faster.
window.addEventListener('resize', changeVideo);